const API = {
    getCanXFrame(url) {
        return this.axiosIns({
            url: `/api-site/virtualTour/canXFrame?url=${encodeURIComponent(
                url
            )}`,
            method: 'get'
        });
    }
};
export default API;
